import { once } from 'stylus/lib/renderer';
import {getValue} from './UsageType'

export default class OtherCharges {
  constructor({
    id = 0,
    orderId = 0,
    rateplanId = 0,
    hardwareId = 0,
    usageType = 'answering',
    contractLength = 0,
    quantity = 0,
    monthlyFee = 0,
    onceOffCharges = 0,
    addressId = '',
    type = 0,
  } = {}) {
    this.id = id;
    this.orderId = orderId;
    this.rateplanId = rateplanId;
    this.hardwareId = hardwareId;
    this.usageType = getValue(usageType);
    this.contractLength = contractLength;
    this.quantity = quantity;
    this.monthlyFee = monthlyFee;
    this.onceOffCharges = onceOffCharges;
    this.addressId = addressId;
    this.type = type;
  }

}
